import { normalizarMateriaId, materiaNoEscopo } from './materiasCompat';
export { MATERIAS } from './perfis';
export const FLASHCARDS=[];
export const installLegacyCards = items => FLASHCARDS.splice(0, FLASHCARDS.length, ...items);
export const getTotalByMateria = () => {
  const totais = {};
  FLASHCARDS.forEach(card => {
    totais[card.materia] = (totais[card.materia] || 0) + 1;
  });
  return totais;
};

export const getCardsByMateria = (materiaId) => {
  return FLASHCARDS.filter(c => normalizarMateriaId(c.materia) === normalizarMateriaId(materiaId));
};

export const getCardsByMaterias = (materias) =>
  FLASHCARDS.filter(c => materiaNoEscopo(c.materia, materias));

export const getCardsByNivel = (materiaId, nivel) => {
  return FLASHCARDS.filter(c => normalizarMateriaId(c.materia) === normalizarMateriaId(materiaId) && c.nivel === nivel);
};
